import { connect } from "react-redux";
import _ from "lodash";

import { fetchPerformanceLeadsGraphReport } from "src/legacy/redux/actions/reports.jsx";
import withUseHooks from "src/legacy/components/withUseHooks";

import LeadView from "./view";

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.legacyRootReducer.reports.performance.leads.loading || false,
    data: state.legacyRootReducer.reports.performance.leads.item || [],
    count:_.sumBy(state.legacyRootReducer.reports.performance.leads.item, (item) => item.value) 
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPerformanceLeadsGraphReport: (filter) => {
      return dispatch(fetchPerformanceLeadsGraphReport(filter));
    },
  };
};

const LeadViewContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LeadView);

export default withUseHooks(LeadViewContainer);